import { render } from "./InfoComponent.vue?vue&type=template&id=50194544&scoped=true"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"

import "./InfoComponent.vue?vue&type=style&index=0&id=50194544&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50194544"]])

export default __exports__